import { h } from "preact";

export default function MiniCartItemBadge({ item }) {
  const badge = item.properties?._badge;
  const badgeColor = item.properties?._badge_color || null;
  if (!badge) return null;

  // For backwards compatibility - previously the badge contained embedded color info
  const [text] = badge.split("||");

  return (
    <div
      className="mini-cart-item__badge"
      style={{ "--badge-color": badgeColor }}
    >
      {text}
    </div>
  );
}
